import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/navbar.css';
import Logo from "../images/logo.png";
import { Link } from "react-router-dom";

const Navigation = () => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  return (
    <div className="navbar-main">
      {['lg'].map((expand) => (
        <Navbar key={expand} expand={expand} className="bg-body-tertiary fixed-top mb-3">
          <Container fluid>
            <Navbar.Brand href="/">
              <img src={Logo} alt="logo" className='logo-nav' />
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls={`offcanvasNavbar-expand-${expand}`}
              onClick={handleShow}
            />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
              show={showOffcanvas}
              onHide={handleClose}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                <Navbar.Brand href="/">
              <img src={Logo} alt="logo" className='logo-nav' />
            </Navbar.Brand>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="navigation-links">
                  <Nav.Link as={Link} to="/" onClick={handleClose}>Home</Nav.Link>
                  <Nav.Link as={Link} to="/projects" onClick={handleClose}>Projects</Nav.Link>
                  <Nav.Link as={Link} to="/service" onClick={handleClose}>Service</Nav.Link>
                  <Nav.Link as={Link} to="/about-us" onClick={handleClose}>About Us</Nav.Link>
                  <Nav.Link as={Link} to="/contact-us" onClick={handleClose}>Contact Us</Nav.Link>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </div>
  );
};

export default Navigation;
